export default __webpack_public_path__ + "static/media/fi_bot.1eafbad0.svg";